import CountryAndRegionState from 'shared/components/forms/state/CountryAndRegionState';
import {observer} from 'mobx-react';
import {withState} from 'shared/core';
import CountrySelect from 'shared/components/forms/country_and_region_selects/CountrySelect';
import RegionSelect from 'shared/components/forms/country_and_region_selects/RegionSelect';
import React from 'react';


const CountryAndRegionSelects = observer(({uiState}) => {
  return (
    <uiState.wrapper>
      <CountrySelect uiState={uiState}/>
      <RegionSelect uiState={uiState}/>
    </uiState.wrapper>
  );
});

CountryAndRegionSelects.defaultProps = {
  defaultToCanada: false,
  renderChildrenInOwnRows: false,
  wrapper: React.Fragment
};

export default withState(CountryAndRegionSelects, CountryAndRegionState, {noSpinner: true});
